module.exports = __webpack_public_path__ + "static/media/user.8e3d85eb.svg";